import { AxiosResponse } from "axios";

import {
  ICognitoMigrationPatient,
  ICognitoMigrationResult,
} from "../../@types/admin/AdminCognitoMigration";
import { IPaginatedResponse } from "../../@types/PaginatedResponse";
import { api } from "../api";

export interface ICognitoMigrationPatientsQuery {
  hospitalGroupId: number;
  wardId?: number;
  search?: string;
  page: number;
  pageSize: number;
}

/**
 * Cognito Migration admin page (EN-5222): a hospital's patients with their
 * Cognito status, and the per-patient migration the page runs over a selection.
 */
export const cognitoMigrationService = {
  async getPatients({
    hospitalGroupId,
    wardId,
    search,
    page,
    pageSize,
  }: ICognitoMigrationPatientsQuery): Promise<
    AxiosResponse<IPaginatedResponse<ICognitoMigrationPatient[]>>
  > {
    return api.get<IPaginatedResponse<ICognitoMigrationPatient[]>>(
      "/Retool/CognitoMigration/Patients",
      {
        params: {
          hospitalGroupId,
          wardId,
          search: search || undefined,
          page,
          pageSize,
        },
      }
    );
  },

  /** Migrates one patient; the response carries the generated password. */
  async migratePatient(
    patientId: number
  ): Promise<AxiosResponse<ICognitoMigrationResult>> {
    return api.post<ICognitoMigrationResult>(
      `/Retool/CognitoMigration/Patients/${patientId}/Migrate`
    );
  },
};
